import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/atendimento`;

export const buscarQuantidadeAtendimentosUsuario = () => {
	return api.get(`${BASE_URL}/quantidade`);
};

export const buscarAtendimentosPaginado = (params, filtros) => {
	return api.get(`${BASE_URL}/paginado`, { params: { ...params, ...filtros } });
};

export const exportarAtendimento = (params, filtros) => {
	return api.get(`${BASE_URL}/exportar`, { params: { ...params, ...filtros }, responseType: "blob" });
};

export const salvarAtendimento = (dados) => api.post(BASE_URL, dados);